var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15028 7.78276L7.49854 8.11311L7.82888 6.46137C7.87237 6.24397 7.97922 6.0443 8.13599 5.88754L12.8323 1.19121C13.2709 0.752668 13.9819 0.752668 14.4205 1.19121C14.859 1.62976 14.859 2.34079 14.4205 2.77931L9.72408 7.47566C9.56732 7.63243 9.36765 7.73928 9.15028 7.78276Z",
    stroke: "#777C80",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73938 2.88379H3.74446C2.50409 2.88379 1.49854 3.88926 1.49854 5.12972V10.7445C1.49854 11.9849 2.50409 12.9905 3.74446 12.9905V14.1134C4.57366 14.1134 5.28983 13.6589 5.67888 12.9905H12.5036C13.744 12.9905 14.7495 11.9849 14.7495 10.7445V5.40181",
    stroke: "#777C80",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74414 10.7446H11.6049",
    stroke: "#777C80",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74414 8.49854H4.86711",
    stroke: "#777C80",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74414 6.25244H4.86711",
    stroke: "#777C80",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/Feedback.b2a3998129771b5a5313c3c40e85321d.svg";
export { ForwardRef as ReactComponent };